import { Box, Stack } from "@mui/material"
import ComplianceDonut from "../../../../components/ComplianceDonut"
import ComplianceAlertBox from "../../../../components/ComplianceAlertBox"
import ComplianceAlertMessage from "../../../../components/ComplianceAlertMessage"
import { Compliance, ItemComplianceStatus } from "../../../../types"
import { Device } from "../../../corp/devices/types"
import { Medication } from "../../../corp/medications/types"
import { useMemo } from "react"

type ComplianceWrapper = {
  label: string,
  image: string,
  items: (Medication | Device)[],
  compliance: Partial<Compliance> | null,
}

const ComplianceWrapper = (props: ComplianceWrapper) => {
  const { label, image, items, compliance } = props

  const values = useMemo(() => {
    const compliances: ItemComplianceStatus[] = items.map(item => {
      const status = item.item_compliance_status
      const compliance = { compliance: { status } }

      return compliance
    })

    return compliances
  }, [items])

  return (
    <Stack direction="row" alignItems="center" paddingY={2} columnGap='32px' className="print-hide">
      <Box className="flex flex-end" sx={{ flexBasis: '50%' }}>
        <ComplianceDonut
          image={image}
          label={label}
          values={values}
        />
      </Box>
      <Box className="flex flex-start" sx={{ flexBasis: '50%' }} >
        <ComplianceAlertBox
          data-testid="compliance-alert-box"
          compliance_status={compliance?.compliance_status ?? 4}
        />
        <ComplianceAlertMessage
          data-testid="compliance-alert-message"
          message={compliance?.message_long ?? ''}
          compliance_status={compliance?.compliance_status ?? 4}
        />        
      </Box>
    </Stack>
  )
}

export default ComplianceWrapper
